export const WHATSAPP_URL = (msg) =>
  `https://wa.me/5511996845494?text=${encodeURIComponent(msg)}`;
